import { DEFAULT_SEGMENT } from '#client/manifest';
import { BANKING_TRANSITION_SEGMENT } from '#client/pages/BankingTransition/constants';

export const DEEP_LINK_PATH = `${DEFAULT_SEGMENT}/${BANKING_TRANSITION_SEGMENT}`;

// The transition flow is hosted by dashboard-ui, whose ingress is always `/dashboard`. This is not
// `useBankingPath`'s job: that hook builds in-MFE paths from PARENT_SEGMENT, which defaults to `/d`
// on a standalone page like this one and would send the customer to a route dashboard-ui does not serve.
export const DASHBOARD_PATH = '/dashboard';

export const BANKING_TRANSITION_DEEP_LINK_PAGE_NAME = 'banking_transition_deep_link';
